import { getEnvironmentVariableByName } from "@ob/core";

const API_THEME = getEnvironmentVariableByName("API_THEME");

export const apiTheme = API_THEME;
